import {
  useState
} from "react"
import ReCAPTCHA from "react-google-recaptcha"
import {
  useNavigate
} from "react-router-dom"
import {
  Container,
  FullRow,
  NormalText,
  PrimaryRowButton,
  RowInput,
  Title
} from "../../components"
import { RECAPTCHA_SITE_KEY } from "../../config"
import { forgotPassword } from "../../endpoints"
import { App } from "antd"



//https://developers.google.com/recaptcha/docs/faq#id-like-to-run-automated-tests-with-recaptcha.-what-should-i-do

export function ForgotPassword(): JSX.Element {
  const [email, setEmail] = useState("")
  const [captchaToken, setCaptchaToken] = useState<string | null>(null)
  const{modal}=App.useApp()
  const handleCaptchaChange = (token: string | null) => {
    setCaptchaToken(token) // Store the token for backend verification
  }

  const navigate = useNavigate()
  
  const handleSubmit = async () => {
    if (!captchaToken) {
      modal.warning({ title: "warning", content: "Please complete the reCAPTCHA" })
      return
    }

    if (!email) {
      modal.warning({ title: "warning", content: "Email cannot be empty" })
      return
    }
    if (email.length > 0) {
      // consolelog("data package", {
      //   email,
      //   captcha: captchaToken,
      // })
      
      const res = await forgotPassword({
        email,
        captcha: captchaToken,
      })
      // consolelog("res", res)
      if (res.code === 1000) {
        // refreshUser?.({ user: res.user ?? "Login" });
        modal.success({
          content:
            "Request submitted, we will send you an email with a link to reset your password.",
        })
        navigate("/")
      } else {
        modal.warning({ content: res.message })
      }
    }
  }

  return (
    <Container style={{ marginTop: "3.5em" }}>
      <FullRow>
        <Title>Forgot Password</Title>
      </FullRow>
      <FullRow>
        <NormalText> Please enter your email address</NormalText>
      </FullRow>

      <FullRow>
        <RowInput
          placeholder="Email Address"
          type="email"
          id="login"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="email"
          maxLength={60}
        />
      </FullRow>
      <FullRow>
        <ReCAPTCHA
          sitekey={RECAPTCHA_SITE_KEY}
          onChange={handleCaptchaChange}
        />
      </FullRow>

      <FullRow>
        <PrimaryRowButton type="primary" onClick={handleSubmit} id="submit">
          Submit
        </PrimaryRowButton>
      </FullRow>
    </Container>
  )
}
